'use strict';

const h = require('phy');

const applyCode = props => {
  const {
    applyCodeText,
    handleApplyClick,
    promoAdditionalMessage,
    promoMessage,
  } = props;

  return h(
    '.apply-code-wrapper',
    h(
      '.promo-v2-message',
      promoMessage,
      h('.promo-v2-additional-message', {
        dangerouslySetInnerHTML: { __html: promoAdditionalMessage },
      })
    ),
    h('.apply-code', { onClick: handleApplyClick }, applyCodeText)
  );
};

module.exports = applyCode;
